import type { KeyboardEvent } from 'react';

/** Flat pickers support searching + Enter, or arrow keys through their visible choices. */
export function slotChoiceKeys(event: KeyboardEvent<HTMLDivElement>) {
  const options = [...event.currentTarget.querySelectorAll<HTMLButtonElement>('button[role="option"]')];
  if (!options.length) return;
  const searching = event.target instanceof HTMLInputElement;
  if (event.key === 'Enter' && searching) {
    event.preventDefault();
    options[0].click();
    return;
  }
  if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) || (searching && ['Home', 'End'].includes(event.key))) return;
  const current = options.indexOf(event.target as HTMLButtonElement);
  const next =
    event.key === 'Home'
      ? 0
      : event.key === 'End'
        ? options.length - 1
        : event.key === 'ArrowDown'
          ? Math.min(current + 1, options.length - 1)
          : current < 0
            ? options.length - 1
            : Math.max(0, current - 1);
  event.preventDefault();
  options[next].focus();
}
